import { useQuery } from '@tanstack/react-query';
import { getInvoiceSeries } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoiceSeries(options = {}) {
    const { data: series = [], isError, isLoading } = useQuery({
        queryKey: ['invoices', 'series'],
        queryFn: getInvoiceSeries,
        onError: (error) => trackError(error),
        ...options,
    });

    return {
        series,
        isLoading,
        isError,
    };
}
